@if (isOpen()) {
  <div
    class="fixed inset-0 z-50 overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
    data-testid="confirm-delete-dialog">
    <!-- Backdrop -->
    <div
      class="fixed inset-0 transition-opacity"
    (click)="onBackdropClick($event)"></div>
    <!-- Dialog Container -->
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
        <!-- Content -->
        <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <!-- Icon -->
            <div
              class="mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10"
            [class.bg-red-100]="variant() === 'danger'"
            [class.bg-yellow-100]="variant() === 'warning'"
            [class.bg-blue-100]="variant() === 'info'">
              @if (variant() === 'danger') {
                <ng-icon
                  name="xMark"
                  class="h-6 w-6 text-red-600"
                  aria-hidden="true"
                  />
              }
              @if (variant() === 'warning') {
                <ng-icon
                  name="exclamationTriangle"
                  class="h-6 w-6 text-yellow-600"
                  aria-hidden="true"
                  />
              }
              @if (variant() === 'info') {
                <ng-icon
                  name="informationCircle"
                  class="h-6 w-6 text-blue-600"
                  aria-hidden="true"
                  />
              }
            </div>
            <!-- Text Content -->
            <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
              <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">
                {{ title() }}
              </h3>
              <div class="mt-2">
                <p class="text-sm text-gray-500">
                  {{ message() }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- Actions -->
        <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <button
            type="button"
            (click)="onConfirm()"
            class="inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm sm:ml-3 sm:w-auto"
          [class.bg-red-600]="variant() === 'danger'"
          [class.hover:bg-red-500]="variant() === 'danger'"
          [class.bg-yellow-600]="variant() === 'warning'"
          [class.hover:bg-yellow-500]="variant() === 'warning'"
          [class.bg-blue-600]="variant() === 'info'"
          [class.hover:bg-blue-500]="variant() === 'info'"
            data-testid="confirm-delete-btn">
            {{ confirmText() }}
          </button>
          <button
            type="button"
            (click)="onCancel()"
            class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
            data-testid="cancel-delete-btn">
            {{ cancelText() }}
          </button>
        </div>
      </div>
    </div>
  </div>
}
